export default __webpack_public_path__ + "18736ecb064d156f37f28babf013b674.png";